<template>
  <div>
    <!-- <b-field :label="$t('measurement_name')" v-if="showMeasurementName()">
      <b-input v-model="inspection.measurementName" :disabled="true" />
    </b-field> -->

    <b-field
      :label="$t('marker_description')"
      v-if="showDescriptionCheckbox() && inspection.hasDescription"
    >
      <b-input v-model="inspection.description" :disabled="true" />
    </b-field>

    <b-field :label="$t('expected_value')" v-if="showExpectedValue()">
      <b-input
        type="number"
        step="any"
        v-model="inspection.expectedValue"
        :disabled="true"
      />
    </b-field>
    <b-field :label="$t('tolerance')" v-if="showTolerance()">
      <b-input
        type="number"
        step="any"
        v-model="inspection.tolerance"
        :disabled="true"
      />
    </b-field>

    <b-field
      grouped
      class="dij-diagrambuilder-inspection-tolerances"
      v-if="showTypeOfTolerance()"
    >
      <b-field
        :label="
          inspection.toleranceType == 'normal' ||
          inspection.toleranceType == 'positive'
            ? $t('positive_tolerance')
            : $t('negative_tolerance')
        "
      >
        <b-input
          type="number"
          step="any"
          v-model="inspection.positiveTolerance"
          disabled
        />
      </b-field>
      <b-field
        :label="
          inspection.toleranceType == 'normal' ||
          inspection.toleranceType == 'negative'
            ? $t('negative_tolerance')
            : $t('positive_tolerance')
        "
      >
        <b-input
          type="number"
          step="any"
          v-model="inspection.negativeTolerance"
          disabled
        />
      </b-field>
    </b-field>

    <template>
      <b-field :label="'Comment'" v-if="showComment()">
        <div
          style="
            max-width: 200px;
            border: 1px solid #ccc;
            padding: 5px;
            border-radius: 4px;
          "
        >
          {{ inspection.inspectorComment }}
        </div>
      </b-field>
    </template>

    <template>
      <template v-if="inspection.type === 'visual'">
        <template v-if="shouldShowVisualInspectionFine(inspection)">
          <span><strong style="color: green">FINE</strong></span>
        </template>
        <div>
          {{ $t('rubbed') }}:
          {{
            inspection.measurements.length !== 0 &&
            inspection.measurements[0].value &&
            inspection.measurements[0].value !== 'notCompleted'
              ? $t(inspection.measurements[0].value)
              : '--'
          }}
        </div>
        <div>
          {{ $t('damaged') }}:
          {{
            inspection.measurements.length !== 0 &&
            inspection.measurements[1].value &&
            inspection.measurements[1].value !== 'notCompleted'
              ? $t(inspection.measurements[1].value)
              : '--'
          }}
        </div>
        <div>
          {{ $t('pitted') }}:
          {{
            inspection.measurements.length !== 0 &&
            inspection.measurements[2].value &&
            inspection.measurements[2].value !== 'notCompleted'
              ? $t(inspection.measurements[2].value)
              : '--'
          }}
        </div>
        <div>
          {{ $t('eroded') }}:
          {{
            inspection.measurements.length !== 0 &&
            inspection.measurements[3].value &&
            inspection.measurements[3].value !== 'notCompleted'
              ? $t(inspection.measurements[3].value)
              : '--'
          }}
        </div>
      </template>
      <template v-else>
        <template
          v-if="
            inspection.type !== 'visual' &&
            inspection.type === 'runout' &&
            !inspection.multipleMeasurements
          "
        >
          <div class="runout-one-measurement">
            <div
              :style="
                isMeasurementOk(inspection, 0)
                  ? 'color:green'
                  : inspection.measurements &&
                    inspection.measurements[0] &&
                    inspection.measurements[0].value === ''
                  ? 'color: black'
                  : 'color:red'
              "
            >
              {{ $t('tir') }}:
              {{
                inspection.measurements.length !== 0 &&
                inspection.measurements[0] &&
                !isNaN(inspection.measurements[0].value)
                  ? inspection.measurements[0].value
                  : '--'
              }}
              <template v-if="getDiff(inspection.measurements[0].value)">
                ({{ getDiff(inspection.measurements[0].value) }})
              </template>
              <template v-if="showUnits()">
                {{ inspection.unit === 'mm' ? 'mm' : 'in' }}
              </template>
            </div>
            <div
              :style="
                isMeasurementOk(inspection, 0)
                  ? 'color:green'
                  : inspection.measurements &&
                    inspection.measurements[0] &&
                    inspection.measurements[0].value === ''
                  ? 'color: black'
                  : 'color:red'
              "
            >
              Pos :
              {{
                inspection.measurements.length !== 0 &&
                inspection.measurements[1] &&
                inspection.measurements[1].value !== ''
                  ? inspection.measurements[1].value
                  : '--'
              }}
              deg
            </div>
          </div>
        </template>
        <template v-else>
          <template
            v-if="inspection.type === 'generic' && inspection.measurementName"
          >
            <span class="generic-label" :title="inspection.measurementName">
              {{ inspection.measurementName + ':' }}
            </span>
          </template>
          <div v-for="number in measurementCount" :key="number">
            <template v-if="inspection.type !== 'freefinding'">
              <template v-if="inspection.type === 'generic'">
                <span
                  v-if="inspection.measurementCount > 1"
                  class="generic-label"
                  :title="inspection.measurements[number - 1].value"
                  :style="
                    isMeasurementOk(inspection, number - 1)
                      ? 'color:green'
                      : isInspectionMeasurementValid(inspection, number - 1)
                      ? 'color: black'
                      : 'color:red'
                  "
                >
                  Pos {{ number }}:
                  {{
                    inspection.measurements[number - 1].value !== ''
                      ? inspection.measurements[number - 1].value
                      : '--'
                  }}
                  <template v-if="getDiff(inspection.measurements[number - 1])">
                    ( {{ getDiff(inspection.measurements[number - 1]) }} )
                  </template>
                  <template v-if="showUnits()" &&>
                    {{ inspection.unit === 'mm' ? 'mm' : 'in' }}
                  </template>
                </span>
                <span
                  v-else
                  class="generic-label"
                  :title="inspection.measurements[0].value"
                  :style="
                    isMeasurementOk(inspection, 0)
                      ? 'color:green'
                      : isInspectionMeasurementValid(inspection, 0)
                      ? 'color: black'
                      : 'color:red'
                  "
                >
                  {{
                    inspection.measurements[0].value !== ''
                      ? inspection.measurements[0].value
                      : '--'
                  }}
                  <template v-if="getDiff(inspection.measurements[0])">
                    ( {{ getDiff(inspection.measurements[0]) }} )
                  </template>
                  <template v-if="showUnits()">
                    {{ inspection.unit === 'mm' ? 'mm' : 'in' }}
                  </template>
                </span>
              </template>
              <template v-else>
                <div
                  :style="
                    isMeasurementOk(inspection, number - 1)
                      ? 'color:green'
                      : isInspectionMeasurementValid(inspection, number - 1)
                      ? 'color: black'
                      : 'color:red'
                  "
                >
                  Pos {{ number }} :
                  {{
                    inspection.measurements &&
                    inspection.measurements[number - 1] &&
                    inspection.measurements[number - 1].value
                      ? inspection.measurements[number - 1].value
                      : '--'
                  }}
                  <template v-if="getDiff(inspection.measurements[number - 1])">
                    ({{ getDiff(inspection.measurements[number - 1]) }})
                  </template>
                  <template v-if="showUnits()">
                    {{ inspection.unit === 'mm' ? 'mm' : 'in' }}
                  </template>
                </div>
              </template>
            </template>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import DESCRIPTION_OPTIONS from './DescriptionOptions';

export default {
  name: 'inspection-tooltip',
  props: ['value'],
  computed: {
    inspection: {
      get() {
        return this.value;
      },
    },
    genericTolerance: {
      get() {
        if (
          this.inspection.expectedValue &&
          this.inspection.positiveTolerance &&
          this.inspection.negativeTolerance
        )
          return true;
        return false;
      },
      set(value) {
        if (value) {
          this.inspection.expectedValue = '0.0000';
          this.inspection.positiveTolerance = '0.0000';
          this.inspection.negativeTolerance = '0.0000';
          this.inspection.toleranceType = 'normal';
        } else {
          this.inspection.expectedValue = undefined;
          this.inspection.positiveTolerance = undefined;
          this.inspection.negativeTolerance = undefined;
          this.inspection.toleranceType = 'normal';
        }
      },
    },

    measurementCount() {
      if (
        !this.inspection.multipleMeasurements &&
        this.inspection.type !== 'runout'
      ) {
        return 1;
      }

      return this.inspection.measurementCount;
    },
  },

  mounted() {
    if (
      this.inspection.hasDescription &&
      this.inspection.descriptionDropdown === 'other'
    ) {
      this.showDescriptionTextBox = true;
    }
  },
  data() {
    return {
      descriptionOptions: DESCRIPTION_OPTIONS,
      showDescriptionTextBox: false,
    };
  },

  methods: {
    showComment() {
      if (
        this.inspection.inspectorComment &&
        this.inspection.inspectorComment !== ''
      ) {
        return true;
      }
      return false;
    },

    getDiff(m) {
      const decimalPlaces = this.inspection.decimalPlaces || 0;
      const measurement = parseFloat(m.value);
      let diff = measurement - parseFloat(this.inspection.expectedValue);
      if (diff > 0) {
        diff = Math.max(
          0,
          diff - parseFloat(this.inspection.positiveTolerance)
        );
      } else if (diff < 0) {
        diff = Math.min(
          0,
          diff + Math.abs(parseFloat(this.inspection.negativeTolerance))
        );
      }

      if (diff === 0 || isNaN(diff)) {
        return false;
      }

      return diff.toFixed(decimalPlaces);
    },

    isMeasurementOk(inspection, measurementNumber) {
      return this.$parent.isMeasurementOk(inspection, measurementNumber);
    },

    isInspectionMeasurementValid(inspection, measurementIndex) {
      if (measurementIndex > inspection.measurements.length) {
        console.error(
          `Inspection ${inspection._id} has measurement count${inspection.measurementCount} but measurements are ${inspection.measurements.length}`
        );
        return false;
      }

      if (inspection.type === 'generic' && !this.genericTolerance) {
        return true;
      }

      return (
        inspection.measurements &&
        inspection.measurements[measurementIndex] &&
        inspection.measurements[measurementIndex].value === ''
      );
    },

    shouldShowVisualInspectionFine(inspection) {
      return (
        inspection.type === 'visual' &&
        !inspection.inTable &&
        inspection.measurements
          .slice(0, 4)
          .every((measurement) => measurement.value === '')
      );
    },

    showUnits() {
      return (
        this.inspection.type === 'diameter' ||
        this.inspection.type === 'runout' ||
        this.inspection.type === 'length' ||
        (this.inspection.type === 'generic' && this.genericTolerance)
      );
    },

    showExpectedValue() {
      return (
        this.inspection.type === 'diameter' ||
        this.inspection.type === 'length' ||
        (this.inspection.type === 'generic' && this.genericTolerance)
      );
    },

    showTolerance() {
      return this.inspection.type === 'runout';
    },

    showText() {
      return this.inspection.type === 'text';
    },

    showTypeOfTolerance() {
      return (
        this.inspection.type === 'diameter' ||
        this.inspection.type === 'length' ||
        (this.inspection.type === 'generic' && this.genericTolerance)
      );
    },

    showDirection() {
      return (
        this.inspection.type === 'runout' &&
        !this.inspection.multipleMeasurements
      );
    },
    // showMeasurementName() {
    //   return this.inspection.type === 'generic';
    // },

    showDescriptionCheckbox() {
      return (
        this.inspection.type !== 'text' &&
        this.inspection.type !== 'arrow' &&
        this.inspection.type !== 'line' &&
        this.inspection.type !== 'position-image'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.dij-diagrambuilder-inspection-unit {
  .control {
    flex: 0 0 50%;
  }
}
.dij-diagrambuilder-inspection-tolerance-type {
  .control {
    flex: 0 0 calc(100% / 3);
  }
}
.dij-diagrambuilder-inspection-orientation {
  .button {
    flex: 0 0 25%;
  }
}
.dij-diagrambuilder-inspection-tolerances {
  ::v-deep div.control input.input {
    width: 70px;
  }
}
.dij-diagrambuilder-inspection-measurementcount {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.rotate-button {
  font-size: 75% !important;
  width: 100% !important;
}
// lower the text size for label and fields
.field ::v-deep label,
.control ::v-deep input {
  font-size: 75%;
}
// Disable the input number arrows
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}

.bold-item {
  font-weight: bold;
}
</style>
